import { useMemo } from 'react'
import { Box, Popper } from '@mui/material'
import { MentionSuggestionsAgentList } from './MentionSuggestionsAgentList.jsx'
import { MentionSuggestionsUserList } from './MentionSuggestionsUserList.jsx'
import styles from './MentionSuggestionsPopover.module.scss'



export default function MentionSuggestionsPopover({
  open,
  anchorEl,
  users = [],
  agents = [],
  activeIndex,
  onHighlight,
  onSelect,
}) {
  const flatItems = useMemo(
    () => [
      ...users.map((u) => ({ ...u, kind: 'user' })),
      ...agents.map((a) => ({ ...a, kind: 'agent' })),
    ],
    [users, agents],
  )
  const hasResults = flatItems.length > 0

  return (
    <Popper
      open={Boolean(open && anchorEl && hasResults)}
      anchorEl={anchorEl}
      placement="top-start"
      modifiers={[{ name: 'offset', options: { offset: [0, 8] } }]}
      popperOptions={{ strategy: 'fixed' }}
      sx={{ zIndex: (theme) => theme.zIndex.modal + 1 }}
    >
      <Box className={styles.root} role="listbox" aria-label="Mention suggestions">
        <Box component="p" className={styles.title}>
          Suggestions
        </Box>
        <Box className={styles.list}>
          <MentionSuggestionsUserList
            users={users}
            activeIndex={activeIndex}
            onHighlight={onHighlight}
            onSelect={onSelect}
          />
          <MentionSuggestionsAgentList
            agents={agents}
            usersLength={users.length}
            activeIndex={activeIndex}
            onHighlight={onHighlight}
            onSelect={onSelect}
          />
        </Box>
      </Box>
    </Popper>
  )
}
